import React, { useState } from 'react';
import { Text, TextVariant } from '@naf/text';
import { AdvancedImage } from '@cloudinary/react';
import { useCloudinary } from '../../../../../hooks/Cloudinary/useCloudinary';
import { TimelineImageType } from '../../../../../../../types/timelineType';
import { TimelineGraph, TimelineTitle } from '../Styles';
import * as S from './Styles';

const TimelineImageItem = ({ item: { title, image } }: { item: TimelineImageType }) => {
  const { getResponsiveImage } = useCloudinary();
  const [timelineImage] = useState(
    getResponsiveImage(image.public_id || image.publicId, {
      width: 320,
      resizeMethod: 'limitFill',
    }),
  );

  return (
    <S.TimelineImage>
      <TimelineTitle>{title && <Text variant={TextVariant.ArticleTextLarge}>{title}</Text>}</TimelineTitle>
      <TimelineGraph $hasImage />
      {timelineImage && <AdvancedImage alt={image?.alt || image?.altText} cldImg={timelineImage} plugins={[]} />}
    </S.TimelineImage>
  );
};

export default TimelineImageItem;
